import { useFeatureToggle } from '@/featureToggles/FeatureTogglesContext';
import { Button, TextField } from '@mui/material';
import { embedDashboard } from '@superset-ui/embedded-sdk';
import { useEffect, useMemo, useState } from 'react';
import './dashboard.css';

const SUPERSET_MIDDLEWARE_URL = 'https://rczu8dm0q8.execute-api.ap-southeast-2.amazonaws.com/prod';

const getSupersetGuestToken = async (
  resourceId: string,
  rls: { clause: string }[],
  useDevUrl: boolean
) => {
  const response = await fetch(
    `${useDevUrl ? 'https://analytics.embed.service.dev.greens.systems' : SUPERSET_MIDDLEWARE_URL}/guest-token`,
    {
      method: 'POST',
      body: JSON.stringify({ resourceId, rls }),
      headers: {
        'Content-Type': 'application/json',
      },
    }
  );
  const jsonBody = await response.json();
  return jsonBody.token;
};

const SupersetDashboard = ({
  resourceId,
  rls = [],
}: {
  resourceId: string;
  rls?: { clause: string }[];
}) => {
  const dashboardElementId = `dashboard-${resourceId}`;

  const isUseDevUrlEnabled = useFeatureToggle('Use dev superset');

  const embed = useMemo(
    () => async (mountPoint: HTMLElement) => {
      await embedDashboard({
        id: resourceId,
        supersetDomain: 'https://analytics.dev.greens.systems/',
        mountPoint,
        fetchGuestToken: () => getSupersetGuestToken(resourceId, rls, isUseDevUrlEnabled),
        dashboardUiConfig: {
          hideTitle: false,
          hideChartControls: true,
          hideTab: true,
        },
        iframeTitle: `Dashboard ${resourceId}`,
      });
    },
    [isUseDevUrlEnabled, resourceId, rls]
  );

  useEffect(() => {
    const mountPoint = document.getElementById(dashboardElementId);
    if (mountPoint) embed(mountPoint);
  }, [dashboardElementId, embed]);

  return (
    <div
      className="supersetDashboard"
      id={dashboardElementId}
      style={{ overflow: 'hidden', height: '100%' }}
    />
  );
};

export const DashboardPage = () => {
  const [rls, setRls] = useState('');
  const [dashboardRls, setDashboardRls] = useState<{ clause: string }[]>([]);

  return (
    <div style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <div>
        <TextField
          fullWidth
          label="RLS in [{'clause': 'string'}] format"
          value={rls}
          onChange={({ target: { value } }) => {
            setRls(value);
          }}
        />
        <Button
          onClick={() => {
            setDashboardRls(JSON.parse(rls));
          }}
        >
          Apply rls
        </Button>
      </div>

      <div style={{ flexGrow: 1 }}>
        <SupersetDashboard resourceId="5d359a80-df4c-44c7-931d-41527b5fd9cc" rls={dashboardRls} />
      </div>
    </div>
  );
};
